'use client';
import React from 'react';
import { FC, ReactElement } from 'react';

const ColsWithForm:FC<{col1: ReactElement, col2: ReactElement}> = ({col1, col2}) => {
    return <div className='min-h-48 py-24'>
        <div className="container flex flex-col items-stretch lg:flex-row gap-40">
            <div className="lg:w-2/5 flex flex-col gap-20">{col1}</div>
            <div className="lg:w-3/5">{col2}</div>
        </div>
    </div>
}

export default ColsWithForm